import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
  lines = Array(4).fill(null).map(_ => new Line());
  
  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll());
  }

  setAllVisible = (status: boolean) => [...this.lines].forEach(l => l.visible = status);
  clearAll = () => this.lines.forEach(l => l.clear());
  draw(points: Coord[]) {
    this.lines[0].draw(points[0], points[2]);
    this.lines[1].draw(points[0], points[3]);
    this.lines[2].draw(points[1], points[2]);
    this.lines[3].draw(points[1], points[3]);
  }
}